// extracted by mini-css-extract-plugin
export default {"chart":"M_fz","fullscreen":"M_c9","close":"M_d8"};